import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

// WHICH publication feed the FeedV2 element ("PlatformFeedElement") renders —
// a manyEntities field name on the host's ambient publication scope def.
// Production twin of the editor option (%/dynamic-component-editor/options/
// platform-feed-selection.js) — same class name, same persisted option key.
// The choice list is host-data-driven; only the editor builds a real picker.
export default class PlatformFeedSelection extends BaseOption {
  static userInterfaceComponent = {
    label: "Feed",
    component: inspectorTools.SIMPLE_PICKER,
    props: {
      options: [],
    },
  };

  static defaultValue = "";
}
